import { render, staticRenderFns } from "./ComplexFont.vue?vue&type=template&id=3535afd6"
import script from "./ComplexFont.vue?vue&type=script&lang=js"
export * from "./ComplexFont.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports